import * as React from 'react';
import {Route, Routes} from 'react-router-dom';
import {Header} from './Header';
import {MarkdownContent} from './MarkdownContent';
import {Home} from './pages/Home';
import {TermineAnmeldung} from './pages/TermineAnmeldung';
import MenuIcon from '@mui/icons-material/Menu';
import {Footer} from './Footer';
import {allPages} from "./data";
import {ContentPage} from "./pages/ContentPage";

type MainProps = {
    handleToggleSidebar: (value: boolean) => void
}

export const Main: React.FC<MainProps> = ({handleToggleSidebar}) => (
    <div className={'main-content-container'}>
        <main>
            <div className="btn-toggle" onClick={() => handleToggleSidebar(true)}>
                <MenuIcon/>
            </div>

            <Header/>

            <Routes>
                <Route path={'/*'} element={<Home/>}/>

                {allPages.map((page) => {
                    return <Route path={'/' + page.path}
                                  element={<ContentPage pageId={page.path} entries={page.elements}/>}/>
                })}
                <Route path={'/termine_anmeldung'} element={<TermineAnmeldung/>}/>

                <Route path={'/impressum'} element={
                    <div className={'page'}>
                        <MarkdownContent file="impressum.md"/>
                    </div>}/>
                <Route path={'/datenschutz'} element={
                    <div className={'page'}>
                        <MarkdownContent file="datenschutz.md"/>
                    </div>}/>
                <Route path={'/agb'} element={
                    <div className={'page'}>
                        <MarkdownContent file="agb.md"/>
                    </div>}/>
            </Routes>

            <Footer/>
        </main>
    </div>
);
